var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M8 0C3.584 0 0 3.585 0 8c0 4.417 3.584 8 8 8 4.424 0 8-3.583 8-8 0-4.415-3.576-8-8-8z",
    fill: "url(#nj6liugdwa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.999 4.264a.71.71 0 0 0-.704.704v3.536c0 .384.32.696.704.696a.696.696 0 0 0 .696-.696V4.968a.704.704 0 0 0-.696-.704zm-.694 6.776c0 .384.312.704.704.704.384 0 .696-.32.696-.704A.698.698 0 0 0 8 10.344a.697.697 0 0 0-.696.696z",
    fill: "url(#nl6aej4fqb)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nj6liugdwa",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nl6aej4fqb",
    x1: 7.295,
    y1: 4.264,
    x2: 7.295,
    y2: 11.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.160951067ec6b2c2172562d19e1f11e9.svg";
export { ForwardRef as ReactComponent };